import { Button, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutInvoiceProcessingToolPanel extends Layout {
    buttonBack: Button;
    buttonCancel: Button;
    buttonOnHold: Button;
    buttonReadyToPrint: Button;
    buttonRemoveHold: Button;
    panel1: Panel;
    panel2: Panel;
    panelButtons: Panel;
}
